import { OnboardingEventId } from '@thoughtspot/onboarding-event-service';
import { enableSpotterVizZeroState } from '@thoughtspot/session-service';
import {
    TourChainActionType,
    TourChainStep,
} from './checklist-tour-steps.util';

export const getSpotterVizTourChain = (
    taskId: string,
    t: (key: string, params?: Record<string, unknown>) => string,
): TourChainStep[] | null => {
    // Flag on → the first prompt lives in the centered zero-state input;
    // flag off → the old panel-docked chat input. Drives step-0 anchoring.
    const isSpotterVizZeroStateFlow = enableSpotterVizZeroState();
    switch (taskId) {
        case OnboardingEventId.SPOTTER_VIZ_BUILD_FIRST_DASHBOARD:
            return [
                {
                    steps: [
                        {
                            target: isSpotterVizZeroStateFlow
                                ? '[data-tour-id="spotter-viz-zero-state-chat-input-send-button-tour"]'
                                : '[data-tour-id="spotter-viz-chat-input-tour"]',
                            title: t('spotterViz.tour.startWithFirstPrompt'),
                            content: t(
                                'spotterViz.tour.customDatasetConnected',
                            ),
                            disableBeacon: true,
                            placement: isSpotterVizZeroStateFlow
                                ? 'right-end'
                                : 'left-end',
                        },
                    ],
                    doneButtonText: t('spotterViz.tour.buildThisDashboard'),
                    afterAction: {
                        selector: isSpotterVizZeroStateFlow
                            ? '[data-tour-id="spotter-viz-zero-state-chat-input-send-button-tour"]'
                            : '[data-tour-id="spotter-viz-chat-input-send-button-tour"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    condition: () =>
                        !document.querySelector(
                            '[data-testid="error-message"]',
                        ),
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="spotter-viz-chat-input-tour"]',
                            title: t('spotterViz.tour.customizeYourDashboard'),
                            content: t(
                                'spotterViz.tour.customizeDashboardDescription',
                            ),
                            disableBeacon: true,
                            placement: 'left-end',
                        },
                    ],
                    doneButtonText: t('spotterViz.tour.customizeThisDashboard'),
                    afterAction: {
                        selector:
                            '[data-tour-id="spotter-viz-chat-input-send-button-tour"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    condition: () =>
                        !document.querySelector(
                            '[data-testid="error-message"]',
                        ),
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="liveboard-styling-edit-header-save-button-tour"]',
                            title: t('spotterViz.tour.saveYourDashboard'),
                            content: t(
                                'spotterViz.tour.saveDashboardDescription',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    doneButtonText: t('spotterViz.tour.saveDashboard'),
                    afterAction: {
                        selector:
                            '[data-tour-id="liveboard-styling-edit-header-save-button-tour"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                },
            ];

        default:
            return null;
    }
};
